import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::availableRooms
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:138
* @route '/bookings/{booking}/items/{bookingItem}/available-rooms'
*/
export const availableRooms = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: availableRooms.url(args, options),
    method: 'get',
})

availableRooms.definition = {
    methods: ["get","head"],
    url: '/bookings/{booking}/items/{bookingItem}/available-rooms',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::availableRooms
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:138
* @route '/bookings/{booking}/items/{bookingItem}/available-rooms'
*/
availableRooms.url = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            booking: args[0],
            bookingItem: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.booking_reference
        : args.booking,
        bookingItem: args.bookingItem,
    }

    return availableRooms.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace('{bookingItem}', parsedArgs.bookingItem.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::availableRooms
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:138
* @route '/bookings/{booking}/items/{bookingItem}/available-rooms'
*/
availableRooms.get = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: availableRooms.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::availableRooms
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:138
* @route '/bookings/{booking}/items/{bookingItem}/available-rooms'
*/
availableRooms.head = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: availableRooms.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::availableRooms
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:138
* @route '/bookings/{booking}/items/{bookingItem}/available-rooms'
*/
const availableRoomsForm = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availableRooms.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::availableRooms
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:138
* @route '/bookings/{booking}/items/{bookingItem}/available-rooms'
*/
availableRoomsForm.get = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availableRooms.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::availableRooms
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:138
* @route '/bookings/{booking}/items/{bookingItem}/available-rooms'
*/
availableRoomsForm.head = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availableRooms.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

availableRooms.form = availableRoomsForm

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::availableRoomTypes
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:161
* @route '/bookings/{booking}/items/{bookingItem}/available-room-types'
*/
export const availableRoomTypes = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: availableRoomTypes.url(args, options),
    method: 'get',
})

availableRoomTypes.definition = {
    methods: ["get","head"],
    url: '/bookings/{booking}/items/{bookingItem}/available-room-types',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::availableRoomTypes
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:161
* @route '/bookings/{booking}/items/{bookingItem}/available-room-types'
*/
availableRoomTypes.url = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            booking: args[0],
            bookingItem: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.booking_reference
        : args.booking,
        bookingItem: args.bookingItem,
    }

    return availableRoomTypes.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace('{bookingItem}', parsedArgs.bookingItem.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::availableRoomTypes
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:161
* @route '/bookings/{booking}/items/{bookingItem}/available-room-types'
*/
availableRoomTypes.get = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: availableRoomTypes.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::availableRoomTypes
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:161
* @route '/bookings/{booking}/items/{bookingItem}/available-room-types'
*/
availableRoomTypes.head = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: availableRoomTypes.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::availableRoomTypes
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:161
* @route '/bookings/{booking}/items/{bookingItem}/available-room-types'
*/
const availableRoomTypesForm = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availableRoomTypes.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::availableRoomTypes
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:161
* @route '/bookings/{booking}/items/{bookingItem}/available-room-types'
*/
availableRoomTypesForm.get = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availableRoomTypes.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::availableRoomTypes
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:161
* @route '/bookings/{booking}/items/{bookingItem}/available-room-types'
*/
availableRoomTypesForm.head = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availableRoomTypes.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

availableRoomTypes.form = availableRoomTypesForm

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::priceAdjustment
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:184
* @route '/bookings/{booking}/items/{bookingItem}/rooms/{room}/price-adjustment'
*/
export const priceAdjustment = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number, room: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number, room: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: priceAdjustment.url(args, options),
    method: 'get',
})

priceAdjustment.definition = {
    methods: ["get","head"],
    url: '/bookings/{booking}/items/{bookingItem}/rooms/{room}/price-adjustment',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::priceAdjustment
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:184
* @route '/bookings/{booking}/items/{bookingItem}/rooms/{room}/price-adjustment'
*/
priceAdjustment.url = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number, room: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number, room: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            booking: args[0],
            bookingItem: args[1],
            room: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.booking_reference
        : args.booking,
        bookingItem: args.bookingItem,
        room: args.room,
    }

    return priceAdjustment.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace('{bookingItem}', parsedArgs.bookingItem.toString())
            .replace('{room}', parsedArgs.room.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::priceAdjustment
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:184
* @route '/bookings/{booking}/items/{bookingItem}/rooms/{room}/price-adjustment'
*/
priceAdjustment.get = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number, room: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number, room: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: priceAdjustment.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::priceAdjustment
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:184
* @route '/bookings/{booking}/items/{bookingItem}/rooms/{room}/price-adjustment'
*/
priceAdjustment.head = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number, room: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number, room: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: priceAdjustment.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::priceAdjustment
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:184
* @route '/bookings/{booking}/items/{bookingItem}/rooms/{room}/price-adjustment'
*/
const priceAdjustmentForm = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number, room: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number, room: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: priceAdjustment.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::priceAdjustment
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:184
* @route '/bookings/{booking}/items/{bookingItem}/rooms/{room}/price-adjustment'
*/
priceAdjustmentForm.get = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number, room: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number, room: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: priceAdjustment.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::priceAdjustment
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:184
* @route '/bookings/{booking}/items/{bookingItem}/rooms/{room}/price-adjustment'
*/
priceAdjustmentForm.head = (args: { booking: string | number | { booking_reference: string | number }, bookingItem: string | number, room: string | number } | [booking: string | number | { booking_reference: string | number }, bookingItem: string | number, room: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: priceAdjustment.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

priceAdjustment.form = priceAdjustmentForm

const items = {
    availableRooms: Object.assign(availableRooms, availableRooms),
    availableRoomTypes: Object.assign(availableRoomTypes, availableRoomTypes),
    priceAdjustment: Object.assign(priceAdjustment, priceAdjustment),
}

export default items